import { useCallback } from 'react';
import '../styles/textarea.css';

export const useTextArea = () => {
  const autoHeight = useCallback((element: HTMLTextAreaElement) => {
    const scrollPos = window.pageYOffset;
    element.style.height = 'auto';
    element.style.height = `${Math.max(element.scrollHeight + 20, 25)}px`;
    window.scrollTo(0, scrollPos);
  }, []);

  const saveNote = useCallback((element: HTMLTextAreaElement) => {
    localStorage.setItem(element.name, element.value);
    autoHeight(element);
  }, [autoHeight]);

  return { autoHeight, saveNote };
};
